

































import Vue from "vue";
import Utils from "../../utils";
import ToolbarHelp from "./ToolbarHelp.vue";
import ToolbarLogo from "./ToolbarLogo.vue";
import ToolbarMenu from "./ToolbarMenu.vue";
import ToolbarMenuButton from "./ToolbarMenuButton.vue";
import ToolbarTitle from "./ToolbarTitle.vue";
import ToolbarTasks from "./ToolbarTasks.vue";
import ToolbarUser from "./ToolbarUser.vue";
import { Statistics } from "@infoland/iprova-api";

export default Vue.extend({
    name: "Toolbar",
    components: {
        ToolbarHelp,
        ToolbarLogo,
        ToolbarMenu,
        ToolbarMenuButton,
        ToolbarTitle,
        ToolbarTasks,
        ToolbarUser
    },
    props: {
        showPortalName: Boolean,
        disablePortalClick: Boolean,
        showPageLocation: Boolean,
        pageLocation: String,
        showDocumentTitle: Boolean,
        documentTitle: String
    },
    data: () => {
        return {
            showMenu: false,
            showPrivacyPolicyDialog: false,
            userMenuId: "userButton",
            communityButtonTryCount: 0,
            isCommunityButtonRendering: false
        };
    },
    computed: {
        userStatistics(): Statistics | null {
            if (this.isAnonymousUser || !this.$user) return null;
            return this.$user.statistics;
        },
        isAnonymousUser(): boolean {
            return Utils.isAnonymousUser(this.$user.user_id);
        },
        hasTabs(): boolean {
            return !!this.$slots.tabs;
        },
        currentRouteName(): String {
            return this.$route?.name;
        },
        currentPortalId(): number | null {
            if (this.$route?.params?.portalId) return parseInt(this.$route.params.portalId);
            else return null;
        },
        mdAndUp(): boolean {
            return this.$vuetify.breakpoint.mdAndUp;
        }
    },
    methods: {
        toggleShowNavigation(): void {
            this.showMenu = !this.showMenu;
        }
    }
});
